export default __webpack_public_path__ + "static/virtual-booth-bg-1-89960a261b9e29889ac7f5eb3ea02dff.jpg";